import {pluralize} from "@pg-mono/string-utils";

// Prices search (hub hero, later the city and address heroes).

// RCN `/v1/addresses?q=` answers 400 above 50, and has no offset or total - a full page means "maybe more".
export const RCN_ADDRESSES_MAX_LIMIT = 50;
export const PRICES_SEARCH_MIN_QUERY_LENGTH = 2;
export const PRICES_SEARCH_DEBOUNCE_MS = 200;
// Rows per group before "Pokaż więcej".
export const PRICES_SEARCH_GROUP_LIMIT = 3;
// Building numbers shown under an expanded street before "Pokaż wszystkie numery".
export const PRICES_SEARCH_NUMBERS_PREVIEW = 6;
export const PRICES_SEARCH_RECENT_SHOWN = 3;
export const PRICES_SEARCH_RECENT_STORED = 10;
// "×" on a main-search entry hides it locally; the list of hidden ids is capped so the entry cannot grow forever.
export const PRICES_SEARCH_RECENT_HIDDEN_IDS_MAX = 50;
// Parallel `price-stats` requests for building numbers and "Adresy" rows.
export const PRICES_SEARCH_NUMBER_PRICES_CONCURRENCY = 3;
// Sanitized RCN queries keep the city token plus the longest words up to this count (RCN ANDs the tokens).
export const PRICES_SEARCH_MAX_RCN_TOKENS = 3;
// "Pokaż więcej ulic" re-queries at most this many cities when the base response was capped.
export const PRICES_SEARCH_SHOW_MORE_MAX_CITIES = 3;
// RP region API page sizes: first look and "Pokaż więcej dzielnic".
export const PRICES_SEARCH_REGIONS_PAGE_SIZE = 10;
export const PRICES_SEARCH_REGIONS_EXPANDED_PAGE_SIZE = 50;
// Shared by the address and region caches: entries and lifetime.
export const PRICES_SEARCH_CACHE_MAX = 50;
export const PRICES_SEARCH_CACHE_TTL_MS = 300_000;
// Same breakpoint as the rest of rp; below it the search opens as a full-screen layer.
export const PRICES_SEARCH_LAYER_MAX_WIDTH_PX = 1023.98;
export const PRICES_SEARCH_GEOLOCATION_TIMEOUT_MS = 10_000;

// "Popularne lokalizacje", in this order. Duplicates with the recent group are kept on purpose.
export const PRICES_SEARCH_POPULAR_CITY_SLUGS = ["warszawa", "krakow", "wroclaw", "gdansk", "poznan"] as const;

export const PRICES_RECENT_SEARCHES_STORAGE_KEY = "rp_prices_recent_searches";
export const PRICES_RECENT_SEARCHES_STORE_VERSION = 1;
// One-shot marker: a city picked in the prices search is mirrored to the main search store on the landing page.
export const PRICES_SEARCH_MIRROR_STORAGE_KEY = "rp_prices_search_mirror";
export const PRICES_SEARCH_MIRROR_MAX_AGE_MS = 60_000;

const suggestionsPluralize = pluralize(["podpowiedź", "podpowiedzi", "podpowiedzi"]);

/** UI copy shared by the model builder and the components. Group titles are sentence case - CSS upper-cases them. */
export const PRICES_SEARCH_COPY = {
    placeholder: "Wpisz miasto lub ulicę",
    inputLabel: "Miasto lub ulica",
    listboxLabel: "Podpowiedzi wyszukiwania",
    layerLabel: "Wyszukaj lokalizację",
    layerBackLabel: "Zamknij wyszukiwanie",
    clearField: "Wyczyść",
    groups: {
        recent: "Ostatnio wyszukiwane",
        popular: "Popularne lokalizacje",
        cities: "Miasta",
        districts: "Dzielnice",
        streets: "Ulice",
        addresses: "Adresy"
    },
    clearRecent: "Wyczyść",
    // "Pokaż więcej {miast|dzielnic|ulic|adresów}" + " ({n})" when the count is known.
    showMore: {
        cities: "Pokaż więcej miast",
        districts: "Pokaż więcej dzielnic",
        streets: "Pokaż więcej ulic",
        addresses: "Pokaż więcej adresów"
    },
    showAllNumbers: "Pokaż wszystkie numery",
    numbersGroupLabel: "Numery budynków",
    // In the price slot of a number or an address RCN publishes no price for (the address page is unavailable).
    noData: "brak danych",
    subtitles: {
        city: "Miasto",
        district: "Dzielnica",
        street: "Ulica",
        address: "Adres"
    },
    subtitleSeparator: " · ",
    // Read after a street row's name: role="option" cannot carry aria-expanded, so the state is part of the name.
    streetState: {expanded: ", rozwinięte", collapsed: ", zwinięte"},
    removeRecent: (title: string) => `Usuń „${title}” z ostatnich wyszukiwań`,
    loading: "Szukamy…",
    diacriticsBanner: "Pokazujemy wyniki dla",
    errorBanner: "Nie udało się pobrać podpowiedzi.",
    retry: "Spróbuj ponownie",
    noResultsTitle: (query: string) => `Nie znaleźliśmy „${query}”`,
    // Front-only RCN: the sentence promising search without Polish characters is dropped.
    noResultsHint: "Sprawdź pisownię albo wpisz nazwę miasta, dzielnicy lub ulicy.",
    cityWithoutDataTitle: (city: string) => `Nie mamy jeszcze cen dla „${city}”`,
    cityWithoutDataHint: "Ceny mieszkań pokazujemy dla 14 największych miast.",
    popularChipsLabel: "Popularne:",
    nearby: {
        title: "Ceny w mojej okolicy",
        subtitle: "Na podstawie lokalizacji urządzenia",
        failed: "Nie udało się ustalić lokalizacji",
        blocked: "Przeglądarka blokuje dostęp do lokalizacji. Zezwól na nią w ustawieniach tej strony, żeby zobaczyć ceny w okolicy.",
        outsideCoverage: (placeName: string) => `Nie mamy jeszcze cen dla ${placeName}`
    },
    live: {
        results: (count: number) => `${count} ${suggestionsPluralize(count)}`,
        error: "Nie udało się pobrać podpowiedzi"
    }
} as const;
import {pluralize} from "@pg-mono/string-utils";

// Prices search (hub hero, later the city and address heroes).

// RCN `/v1/addresses?q=` answers 400 above 50, and has no offset or total - a full page means "maybe more".
export const RCN_ADDRESSES_MAX_LIMIT = 50;
export const PRICES_SEARCH_MIN_QUERY_LENGTH = 2;
export const PRICES_SEARCH_DEBOUNCE_MS = 200;
// Rows per group before "Pokaż więcej".
export const PRICES_SEARCH_GROUP_LIMIT = 3;
// Building numbers shown under an expanded street before "Pokaż wszystkie numery".
export const PRICES_SEARCH_NUMBERS_PREVIEW = 6;
export const PRICES_SEARCH_RECENT_SHOWN = 3;
export const PRICES_SEARCH_RECENT_STORED = 10;
// "×" on a main-search entry hides it locally; the list of hidden ids is capped so the entry cannot grow forever.
export const PRICES_SEARCH_RECENT_HIDDEN_IDS_MAX = 50;
// Parallel `price-stats` requests for building numbers and "Adresy" rows.
export const PRICES_SEARCH_NUMBER_PRICES_CONCURRENCY = 3;
// Sanitized RCN queries keep the city token plus the longest words up to this count (RCN ANDs the tokens).
export const PRICES_SEARCH_MAX_RCN_TOKENS = 3;
// "Pokaż więcej ulic" re-queries at most this many cities when the base response was capped.
export const PRICES_SEARCH_SHOW_MORE_MAX_CITIES = 3;
// RP region API page sizes: first look and "Pokaż więcej dzielnic".
export const PRICES_SEARCH_REGIONS_PAGE_SIZE = 10;
export const PRICES_SEARCH_REGIONS_EXPANDED_PAGE_SIZE = 50;
// Shared by the address and region caches: entries and lifetime.
export const PRICES_SEARCH_CACHE_MAX = 50;
export const PRICES_SEARCH_CACHE_TTL_MS = 300_000;
// Same breakpoint as the rest of rp; below it the search opens as a full-screen layer.
export const PRICES_SEARCH_LAYER_MAX_WIDTH_PX = 1023.98;
export const PRICES_SEARCH_GEOLOCATION_TIMEOUT_MS = 10_000;

// "Popularne lokalizacje", in this order. Duplicates with the recent group are kept on purpose.
export const PRICES_SEARCH_POPULAR_CITY_SLUGS = ["warszawa", "krakow", "wroclaw", "gdansk", "poznan"] as const;

export const PRICES_RECENT_SEARCHES_STORAGE_KEY = "rp_prices_recent_searches";
export const PRICES_RECENT_SEARCHES_STORE_VERSION = 1;
// One-shot marker: a city picked in the prices search is mirrored to the main search store on the landing page.
export const PRICES_SEARCH_MIRROR_STORAGE_KEY = "rp_prices_search_mirror";
export const PRICES_SEARCH_MIRROR_MAX_AGE_MS = 60_000;

const suggestionsPluralize = pluralize(["podpowiedź", "podpowiedzi", "podpowiedzi"]);

/** UI copy shared by the model builder and the components. Group titles are sentence case - CSS upper-cases them. */
export const PRICES_SEARCH_COPY = {
    placeholder: "Wpisz miasto lub ulicę",
    inputLabel: "Miasto lub ulica",
    listboxLabel: "Podpowiedzi wyszukiwania",
    layerLabel: "Wyszukaj lokalizację",
    layerBackLabel: "Zamknij wyszukiwanie",
    clearField: "Wyczyść",
    groups: {
        recent: "Ostatnio wyszukiwane",
        popular: "Popularne lokalizacje",
        cities: "Miasta",
        districts: "Dzielnice",
        streets: "Ulice",
        addresses: "Adresy"
    },
    clearRecent: "Wyczyść",
    // "Pokaż więcej {miast|dzielnic|ulic|adresów}" + " ({n})" when the count is known.
    showMore: {
        cities: "Pokaż więcej miast",
        districts: "Pokaż więcej dzielnic",
        streets: "Pokaż więcej ulic",
        addresses: "Pokaż więcej adresów"
    },
    showAllNumbers: "Pokaż wszystkie numery",
    numbersGroupLabel: "Numery budynków",
    // In the price slot of a number or an address RCN publishes no price for (the address page is unavailable).
    noData: "brak danych",
    subtitles: {
        city: "Miasto",
        district: "Dzielnica",
        street: "Ulica",
        address: "Adres"
    },
    subtitleSeparator: " · ",
    // Read after a street row's name: role="option" cannot carry aria-expanded, so the state is part of the name.
    streetState: {expanded: ", rozwinięte", collapsed: ", zwinięte"},
    removeRecent: (title: string) => `Usuń „${title}” z ostatnich wyszukiwań`,
    loading: "Szukamy…",
    diacriticsBanner: "Pokazujemy wyniki dla",
    errorBanner: "Nie udało się pobrać podpowiedzi.",
    retry: "Spróbuj ponownie",
    noResultsTitle: (query: string) => `Nie znaleźliśmy „${query}”`,
    // Front-only RCN: the sentence promising search without Polish characters is dropped.
    noResultsHint: "Sprawdź pisownię albo wpisz nazwę miasta, dzielnicy lub ulicy.",
    cityWithoutDataTitle: (city: string) => `Nie mamy jeszcze cen dla „${city}”`,
    cityWithoutDataHint: "Ceny mieszkań pokazujemy dla 14 największych miast.",
    popularChipsLabel: "Popularne:",
    nearby: {
        title: "Ceny w mojej okolicy",
        subtitle: "Na podstawie lokalizacji urządzenia",
        failed: "Nie udało się ustalić lokalizacji",
        blocked: "Przeglądarka blokuje dostęp do lokalizacji. Zezwól na nią w ustawieniach tej strony, żeby zobaczyć ceny w okolicy.",
        outsideCoverage: (placeName: string) => `Nie mamy jeszcze cen dla ${placeName}`
    },
    live: {
        results: (count: number) => `${count} ${suggestionsPluralize(count)}`,
        error: "Nie udało się pobrać podpowiedzi"
    }
} as const;
